document.addEventListener('DOMContentLoaded', function () {
    // Attach click event listener for .tm-qlower
    document.body.addEventListener('click', function (event) {
        if (event.target.classList.contains('tm-qlower')) {
            const wrap = event.target.closest('.mpc-product-quantity')
            const input = wrap.querySelector('input[type="number"]')

            let min = 0
            if (input.dataset.min !== undefined) {
                min = parseInt(input.dataset.min, 10)
            }

            let qty = parseInt(input.value, 10)
            if (qty !== undefined && qty > min) {
                input.value = qty - 1
                // Use jQuery to trigger the 'input' event
                jQuery(input).trigger('input')
                jQuery(input).trigger('change')
            }
        }
    })

    // Attach click event listener for .tm-qhigher
    document.body.addEventListener('click', function (event) {
        if (event.target.classList.contains('tm-qhigher')) {
            const wrap = event.target.closest('.mpc-product-quantity')
            const input = wrap.querySelector('input[type="number"]')

            let qty = parseInt(input.value, 10)

            if (input.dataset.max !== undefined) {
                const max = parseInt(input.dataset.max, 10)

                if (qty >= max) {
                    return
                }
            }

            input.value = qty + 1
            // Use jQuery to trigger the 'input' event
            jQuery(input).trigger('input')
            jQuery(input).trigger('change')
        }
    })
})
